// 电脑端入口页

import { useState, useEffect } from 'react'
import RouterConfig from './common/router_config'
import { BrowserRouter as Router } from 'react-router-dom'
import './styles/common.css'
import './App.css'
import 'antd/dist/antd.css'
import { Button, ConfigProvider, BackTop, Modal, notification, message } from 'antd'
import { UpCircleOutlined, PoweroffOutlined, } from '@ant-design/icons';
import url from './common/url_config'
import fun from './common/common_fun'
import zhCN from 'antd/es/locale/zh_CN';
import cookie from 'react-cookies'
import NavTop from './components/menu/nav'
import FooterBottom from './components/menu/footer'
import huijv from './common/huijv'


function App() {
  let [language, set_language] = useState(window.location.href.indexOf('?lan=en') === -1 ? 'Chinese' : 'English')
  let [loading, set_loading] = useState(false)//加载中

  function addTrackScript() {
    var sdk = document.createElement("script");
    sdk.onload = function () {
      console.log('SDK加载成功')
      var setting = document.createElement("script");
      setting.innerHTML = 'clab_tracker.setEnableAutoTrackOpenPage(false)\n' +
        'clab_tracker.setEnableAutoTrackExitPage(false)\n' +
        'clab_tracker.setEnableAutoTrackClick(false)\n'

      document.getElementsByTagName("head")[0].appendChild(setting);
      console.log(window.clab_tracker)
      window.clab_tracker.ready(function () {
        // 荟聚
        // huijv.open_page({
        //   "targetName": "入口页",
        //   "targetId": 'home',
        // })
      });
    };

    sdk.setAttribute(
      "src",
      "//cbe.huiju.cool/cbe/collect?tid=8707773680201087529&at=0&h=web"
    );
    document.getElementsByTagName("head")[0].appendChild(sdk);

  }

  const ask_accept_convertlab = (lan) => {
    if (!localStorage.getItem('accept_consent') || localStorage.getItem('accept_consent') !== '1') {
      Modal.confirm({
        title: lan === 'Chinese' ? '是否同意采集浏览信息？' : 'Do you agree to collect browsing information?',
        // content: '是否同意采集',
        onOk: () => {
          // 同意
          addTrackScript()
          localStorage.setItem('accept_consent', '1')
        },
        onCancel: () => {
          console.log('不同意')
        }
      })
    } else {
      // 已经同意过了
      addTrackScript()
    }
  }

  // 获取通知消息
  const get_notice = () => {
    set_loading(true)
    fun['post_data'](url + 'get_notice', {}).then(res => {
      if (res.status) {
        if (res.result.rows.length === 0) {
          return
        }

        console.log(res.result.rows)
        let temp_index = Number(cookie.load('has_show_notices')) || 0
        res.result.rows.map((item) => {
          // if (item.id <= temp_index) {
          //   return
          // }
          let url_set = ['https://aiotcloud.nxp.com.cn/?lan=en', 'https://aiotcloud.nxp.com.cn/', 'https://aiotcloud.nxp.com.cn',]
          if (url_set.indexOf(window.location.href) !== -1) {
            notification.info({
              message: language === 'Chinese' ? item.title_ch : item.title_en,
              description: language === 'Chinese' ? item.content_ch : item.content_en,
              placement: 'topLeft',
              duration: null,
            });
          }
        })
        cookie.save('has_show_notices', String(res.result.rows[0]['id']), { path: '/' })
      } else {
        message.error(JSON.stringify(language === 'Chinese' ? res.result : (res.result_en || res.result)))
      }
      set_loading(false)
    })
  }

  // 检测是否正常登录
  const test_is_normal_login_status = () => {
    fun['post_data'](url + 'test_is_normal_login_status', {}).then(res => {
      if (!res.status) {
        cookie.remove('login_role',)
        cookie.save('login_username', '', { path: '/' })
        cookie.remove('session_key')

        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    })
  }

  useEffect(() => {
    // 从URL判断语言
    let temp_url = window.location.href
    if (temp_url.indexOf('?lan=en') > -1) {
      set_language('English')
      cookie.save('language', 'English', { path: '/' })
    } else {
      set_language('Chinese')
      cookie.save('language', 'Chinese', { path: '/' })
    }

    let pathname = window.location.pathname
    console.log('首页打印登录id', cookie.load('login_id'), pathname)

    // 301跳转
    // if (pathname === '/overview') {
    //   window.location.href = '/product/overview'
    //   return
    // } else if (pathname === '/product/product_line_all') {
    //   window.location.href = '/product/all'
    //   return
    // } else if (pathname === '/solution_show/EasyEVSE_Development_Platform') {
    //   window.location.href = '/solution-show/easyevse-development-platform'
    //   return
    // } else if (pathname === '/ddr_imx93_evk_board0') {
    //   window.location.href = '/software/ddr-imx93-evk-board-0'
    //   return
    // } else if (pathname === '/user_case') {
    //   window.location.href = '/use-case'
    //   return
    // } else if (pathname === '/user_case_show/Functions_Experience') {
    //   window.location.href = '/use-case-show/mcu-products-function-experience'
    //   return
    // } else if (pathname === '/user_case_show/i.MX%20Products%20Use%20Case') {
    //   window.location.href = '/use-case-show/imx-poducts-function-experience'
    //   return
    // } else if (pathname === '/user_case_show/Partner%20Use%20Case') {
    //   window.location.href = '/use-case-show/partner-products-function-experience'
    //   return
    // } else if (pathname === '/faq') {
    //   window.location.href = '/support'
    //   return
    // }

    let lan = navigator.languages.length > 0 ? (navigator.languages[0].indexOf('zh') > -1 ? "Chinese" : 'English') : 'English'

    // 询问是否同意荟聚收集
    ask_accept_convertlab(lan)
    // addTrackScript()

    // 获取通知
    get_notice()
    if (cookie.load('login_username')) {
      test_is_normal_login_status()
    }
  }, [])

  return (
    <div className='main_root'>
      <BackTop>
        <div style={{ backgroundColor: '#1088e9', color: 'white', opacity: 0.5, width: 40, height: 40, textAlign: 'center', lineHeight: '48px' }} ><UpCircleOutlined style={{ fontSize: 25 }} /></div>
      </BackTop>

      {/* 顶部导航 */}
      <NavTop />

      <div style={{ clear: 'both' }}></div>

      <Router basename='/nxp'>
        <div style={{ width: '100%', marginTop: 0, overflow: 'auto', backgroundColor: '#f5f5f5' }}>
          <div style={{ width: '100%' }} className='router'>
            {language === 'Chinese' ? <ConfigProvider locale={zhCN}><RouterConfig /></ConfigProvider> : <RouterConfig />}
          </div>
        </div>
      </Router>

      {/* 底部公共 */}
      <FooterBottom />
    </div>
  );
}

export default App;